import React, { Component } from "react";
import Image from "react-bootstrap/Image";
import { NavLink } from "react-router-dom";
import RightSidePannel from "../rightSidePannelReusable/RightSidePannel";
import { TopTextReusableComponent } from "../../reusableOnboardingComponent/TopTextReusable/TopTextReusableComponent";
import Form from "react-bootstrap/Form";
import {
  ReusableOnboardingButton,
  ReusableOnboardingLink,
  ReusableOnboardingMapButton,
} from "../../reusableOnboardingComponent/ButtonReusable/ReusableOnboardingButton";
import SuggestNewButton from "../../reusableOnboardingPopupComponent/suggestNew/SuggestNewButton";
import { CuisineSetupHomeScreen } from "./CuisineSetupHomeScreen";
import SlidingComponent from "../../../reusableComponents/slidingToggleComponent/SlidingComponent";
import isEmpty from "../../../../store/validation/is-Empty";

import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { clear_all_errors } from "../../../../store/actions/errorActions";
import { create_and_update_restaurant } from "../../../../store/actions/authAction";
import { AmealioLoader } from "../../../Loader/AmealioLoader";
import { NewInputText } from "../../../reusableComponents/inputReusableComponent/InputBoxComponent";
import { SliderReusableComponent } from "../../../reusableComponents/sliderReusableComponent/SliderReusableComponent";
import { BackLogoIconButton } from "../../../reusableComponents/smallReusableComponent/LoginTopLogoAndText";
import Media from "react-media";
import { MobileTopHeader } from "../../../reusableComponents/sliderReusableComponent/MobileTopHeader";
import { SliderMobileReusableComponent } from "../../../reusableComponents/sliderReusableComponent/SliderMobileReusableComponent";
import { LearnMore } from "../restaurantDetailsLogoVideo/RestaurantDetailsLogoVideo";
const personalizationfalse =
  "All the items we serve are standardized no further personalization is offered";
const allergicInfofalse =
  "No Allergy information is available for dishes on the menu, you can check ingredients of the item";
const nutritionInfofalse =
  "No Nutrition information is available for dishes on the menu.";
const personalizationtrue =
  "Personalization is offered at this place , you can see information on specific menu items for which this Option is available e.g. if you allow users to request for less salt, sugar or other things you can let them know here and also use those features";
const allergicInfotrue =
  "Write about allergy info e..g. if you cook your food in peanut oil or specific flour , it will be shown to user";
const nutritionInfotrue =
  "Write if nutrition information if available all or specific items e.g. Items are available in different sizes and nutrition option";

export class CuisineSetupOnboarding extends Component {
  constructor(props) {
    super(props);
    this.state = {
      actionButton: false,
      selectedTab: 2,
      displayHomeCuisine: false,
      personalization: true,
      allergic_information: true,
      nutrition_information: true,
      personalizationText: "",
      allergicInfoText: "",
      nutritionInfoText: "",
      serve_liquor: false,
      all_food_category: [],
      selected_food_category: [],
      primary_food_category: {},
      all_serve_liquor: [],
      selected_liquor_category: [],
      errors: {},
      formShow: false,
    };
  }

  componentDidMount() {
    if (this.props.auth.loader) {
      this.setState({
        loader: true,
      });
    }
  }

  static getDerivedStateFromProps(nextProps, nextState) {
    if (
      !isEmpty(nextProps.onboarding._id) &&
      !isEmpty(nextProps.foodcategory) &&
      !isEmpty(nextProps.liquorcategory) &&
      !nextState.hasSetMapProps
    ) {
      let selected_food_category = nextProps.onboarding.selected_food_category;
      let primary_food_category = nextProps.onboarding.primary_food_category;
      let selected_liquor_category =
        nextProps.onboarding.selected_liquor_category;
      if (
        !isEmpty(selected_liquor_category[0]) &&
        !isEmpty(selected_food_category[0]) &&
        !isEmpty(nextProps.onboarding.primary_food_category)
      ) {
        if (
          nextProps.onboarding.primary_food_category !== "" &&
          isEmpty(selected_food_category[0]._id) &&
          selected_food_category.length > 0 &&
          isEmpty(selected_liquor_category[0]._id) &&
          selected_liquor_category.length > 0 &&
          isEmpty(primary_food_category._id)
        ) {
          selected_food_category = nextProps.foodcategory.filter(
            (foodcategory) => selected_food_category.includes(foodcategory._id)
          );
          selected_liquor_category = nextProps.liquorcategory.filter(
            (foodcategory) =>
              selected_liquor_category.includes(foodcategory._id)
          );
          primary_food_category = nextProps.foodcategory.filter(
            (foodcategory) => foodcategory._id === primary_food_category
          )[0];
        }
      }
      let all_food_category = nextProps.foodcategory.filter(
        (foodcategory) =>
          !selected_food_category.some(
            (selected) => selected._id === foodcategory._id
          ) && foodcategory.status !== "NOTAPPROVED"
      );
      return {
        all_food_category: all_food_category,
        all_serve_liquor: nextProps.liquorcategory,
        selected_food_category: !isEmpty(selected_food_category)
          ? selected_food_category
          : [],
        primary_food_category: !isEmpty(primary_food_category)
          ? primary_food_category
          : {},
        selected_liquor_category: !isEmpty(selected_liquor_category)
          ? selected_liquor_category
          : [],
        personalization: nextProps.onboarding.personalization_information,
        allergic_information: nextProps.onboarding.allergic_information,
        nutrition_information: nextProps.onboarding.nutrition_information,
        personalizationText: !isEmpty(
          nextProps.onboarding.personalization_information_description
        )
          ? nextProps.onboarding.personalization_information_description
          : "All the items we serve are standardized no further personalization is offered",
        allergicInfoText: !isEmpty(nextProps.onboarding.allergicInfoText)
          ? nextProps.onboarding.allergicInfoText
          : "No Allergy information is available for dishes on the menu, you can check ingredients of the item",
        nutritionInfoText: !isEmpty(nextProps.onboarding.nutritionInfoText)
          ? nextProps.onboarding.nutritionInfoText
          : "No Nutrition information is available for dishes on the menu.",
        serve_liquor: nextProps.onboarding.serve_liquor,
        displayHomeCuisine:
          nextProps.onboarding.allergic_information === true ||
          nextProps.onboarding.nutrition_information === true ||
          nextProps.onboarding.serve_liquor === true ||
          selected_food_category.length > 0 ||
          selected_liquor_category.length > 0
            ? true
            : false,
        hasSetMapProps: true,
      };
    }
    if (nextProps.auth.loader !== nextState.loader) {
      return {
        loader: nextProps.auth.loader,
      };
    }
    if (nextProps.errors !== nextState.errors) {
      return {
        errors: nextProps.errors,
      };
    }
    return null;
  }

  onChange = (e) => {
    let data = e.target.value.split(" ");
    let newarray1 = [];
    for (let x = 0; x < data.length; x++) {
      newarray1.push(data[x].charAt(0).toUpperCase() + data[x].slice(1));
    }
    let newData = newarray1.join(" ");
    this.setState({
      [e.target.name]: newData,
      actionButton: true,
    });
  };

  onFocusOut = (e) => {
    const { errors } = this.state;
    if (e.target.value === "") {
      errors[
        e.target.name
      ] = `*Fields can’t be blank. Please enter your ${e.target.name}`;
    } else {
      errors[e.target.name] = "";
    }
    this.setState({
      errors: errors,
    });
  };

  onPageChangeHandler = (e) => {
    e.preventDefault();
    this.setState({
      displayHomeCuisine: true,
    });
  };
  onPageChangeHandlerClosed = (e) => {
    e.preventDefault();
    this.setState({
      displayHomeCuisine: false,
    });
  };

  /**************************
   * @DESC - Current and Saving HANDLER
   ***************************/
  toggleFunction = (type) => (e) => {
    if (type === "personalization" && this.state.personalization === true) {
      this.setState({
        personalizationText: personalizationfalse,
        [e.target.name]: e.target.checked,
        actionButton: true,
      });
    } else if (
      type === "personalization" &&
      this.state.personalization === false
    ) {
      this.setState({
        personalizationText: personalizationtrue,
        [e.target.name]: e.target.checked,
        actionButton: true,
      });
    } else if (type === "allergy" && this.state.allergic_information === true) {
      this.setState({
        allergicInfoText: allergicInfofalse,
        [e.target.name]: e.target.checked,
        actionButton: true,
      });
    } else if (
      type === "allergy" &&
      this.state.allergic_information === false
    ) {
      this.setState({
        allergicInfoText: allergicInfotrue,
        [e.target.name]: e.target.checked,
        actionButton: true,
      });
    } else if (
      type === "nutritionInfo" &&
      this.state.nutrition_information === true
    ) {
      this.setState({
        nutritionInfoText: nutritionInfofalse,
        [e.target.name]: e.target.checked,
        actionButton: true,
      });
    } else if (
      type === "nutritionInfo" &&
      this.state.nutrition_information === false
    ) {
      this.setState({
        nutritionInfoText: nutritionInfotrue,
        [e.target.name]: e.target.checked,
        actionButton: true,
      });
    }
  };

  toggleFunctionliquor = (e) => {
    this.setState({
      [e.target.name]: e.target.checked,
      selected_liquor_category: [],
      actionButton: true,
    });
  };

  /*********************************************
   * @DESC - select food category
   *********************************************/
  onRestaurantFoodTypeArraySelector = (icon, index) => (e) => {
    let buttonArray = this.state.all_food_category;
    buttonArray.splice(index, 1);
    let Restaurant = this.state.selected_food_category;
    let primaryIcon = this.state.primary_food_category;
    if (Restaurant.length === 0 || primaryIcon === {}) {
      Restaurant.push(icon);
      this.setState({
        selected_food_category: Restaurant,
        primary_food_category: icon,
        actionButton: true,
      });
    } else {
      let isAlreadyPresent = Restaurant.includes(icon);
      if (isAlreadyPresent) {
        let indexOf = Restaurant.indexOf(icon);
        if (indexOf === 0 || indexOf) {
          Restaurant.splice(indexOf, 1);
        }
      } else {
        Restaurant.push(icon);
      }
    }
    this.setState({
      selected_food_category: Restaurant,
      actionButton: true,
    });
  };

  onRestaurantsFoodTypePrimarySelector = (icon) => (e) => {
    this.setState({
      primary_food_category: icon,
      actionButton: true,
    });
  };

  /****************************************
   * @DESC - Remove Primary button handler
   ****************************************/
  removeButton = (icon) => (e) => {
    let { all_food_category, selected_food_category, primary_food_category } =
      this.state;

    let iconIndexAtAllIcons = all_food_category.findIndex(
      (icons) => icons._id === icon._id
    );
    let iconIndexAtSelectedIcons = selected_food_category.findIndex(
      (icons) => icons._id === icon._id
    );
    let iconAtPrimaryIcon =
      !isEmpty(primary_food_category) && primary_food_category._id === icon._id
        ? true
        : false;
    if (selected_food_category.length === 0) {
      selected_food_category.push(icon);
      all_food_category.splice(iconIndexAtAllIcons, 1);
      primary_food_category = icon;
    } else if (iconAtPrimaryIcon) {
      selected_food_category.splice(iconIndexAtSelectedIcons, 1);
      all_food_category.push(icon);
      if (selected_food_category.length === 1) {
        primary_food_category = selected_food_category[0];
      } else {
        primary_food_category = {};
      }
    } else if (iconIndexAtSelectedIcons === 0 || iconIndexAtSelectedIcons) {
      selected_food_category.splice(iconIndexAtSelectedIcons, 1);
      all_food_category.push(icon);
      if (selected_food_category.length === 1) {
        primary_food_category = selected_food_category[0];
      }
    } else {
      selected_food_category.push(icon);
      all_food_category.splice(iconIndexAtAllIcons, 1);
    }

    this.setState({
      selected_food_category: selected_food_category,
      all_food_category: all_food_category,
      primary_food_category: primary_food_category,
      actionButton: true,
    });
  };

  // onSelectFoodCategoryArraySelector = (icon) => (e) => {
  //   e.preventDefault();
  //   let { selected_food_category } = this.state;
  //   let iconIndexAtSelectedIcons = selected_food_category.findIndex(
  //     (icons) => icons._id === icon._id
  //   );
  //   if (
  //     (iconIndexAtSelectedIcons === 0 || iconIndexAtSelectedIcons) &&
  //     iconIndexAtSelectedIcons !== -1
  //   ) {
  //     selected_food_category.splice(iconIndexAtSelectedIcons, 1);
  //   } else {
  //     selected_food_category.push(icon);
  //   }
  //   this.setState({
  //     selected_food_category: selected_food_category,
  //     actionButton: true,
  //   });
  // };

  /*********************************************
   * @DESC - selected serve liquor
   *********************************************/
  onSelectedServeLiquorArraySelector = (icon) => (e) => {
    e.preventDefault();
    let { selected_liquor_category } = this.state;
    let iconIndexAtSelectedIcons = selected_liquor_category.findIndex(
      (icons) => icons._id === icon._id
    );
    if (
      (iconIndexAtSelectedIcons === 0 || iconIndexAtSelectedIcons) &&
      iconIndexAtSelectedIcons !== -1
    ) {
      selected_liquor_category.splice(iconIndexAtSelectedIcons, 1);
    } else {
      selected_liquor_category.push(icon);
    }
    this.setState({
      selected_liquor_category: selected_liquor_category,
      actionButton: true,
    });
  };

  onWithOutApiCall = (e) => {
    this.props.history.push({
      pathname: "/foodtype",
    });
  };

  onHandleSubmit = (e) => {
    e.preventDefault();
    if (
      this.props.onboarding &&
      this.props.onboarding.selected_food_category.length > 0
    ) {
      const formData = {
        vendor_id: this.props.onboarding.vendor_id,
        id: this.props.onboarding._id,
        personalization_information: this.state.personalization,
        allergic_information: this.state.allergic_information,
        nutrition_information: this.state.nutrition_information,
        serve_liquor: this.state.serve_liquor,
        selected_food_category: this.state.selected_food_category,
        primary_food_category: this.state.primary_food_category,
        selected_liquor_category: this.state.selected_liquor_category,
        personalization_information_description: this.state.personalizationText,
        allergicInfoText: this.state.allergicInfoText,
        nutritionInfoText: this.state.nutritionInfoText,
      };
      this.props.create_and_update_restaurant(formData);
      this.props.history.push("/foodtype");
    } else {
      const formData = {
        vendor_id: this.props.onboarding.vendor_id,
        id: this.props.onboarding._id,
        personalization_information: this.state.personalization,
        allergic_information: this.state.allergic_information,
        nutrition_information: this.state.nutrition_information,
        serve_liquor: this.state.serve_liquor,
        selected_food_category: this.state.selected_food_category,
        primary_food_category: this.state.primary_food_category,
        selected_liquor_category: this.state.selected_liquor_category,
        personalization_information_description: this.state.personalizationText,
        allergicInfoText: this.state.allergicInfoText,
        nutritionInfoText: this.state.nutritionInfoText,
        page_completed_till: 17,
      };
      this.props.create_and_update_restaurant(formData);
      this.props.history.push("/foodtype");
    }
  };

  renderCuisineSetupInsideFields = (
    allFoodIcons,
    selectedFoodIcons,
    primaryFoodCategory,
    allLiquorIcons,
    selectedLiquorIcons,
    personalization
  ) => {
    const {
      // personalization,
      allergic_information,
      nutrition_information,
      serve_liquor,
      actionButton,
      errors,
    } = this.state;
    return (
      <React.Fragment>
        <div className="restaurant_type_onboarding_main">
          <div>
            <div className="cuisine-main ">
              <div className="f14-700 pb-3">
                What Food Category do you provide?
              </div>
              <div
                className={
                  allFoodIcons.length > 8 ? "cuisine-main-padding-border" : ""
                }
              >
                <div
                  id="box-style"
                  className="cuisine-main-padding justify-content-start column-2"
                  style={{ display: "flex", flexWrap: "wrap" }}
                >
                  {allFoodIcons.map((icon, index) => (
                    <ReusableOnboardingMapButton
                      key={index}
                      classsection={
                        selectedFoodIcons.includes(icon)
                          ? "onboarding_mapbutton_reusable onboarding_mapbutton_reusable_type "
                          : "onboarding_mapbutton_reusable onboarding_mapbutton_reusable_type"
                      }
                      src={icon.icon}
                      title={icon.title}
                      onClick={this.onRestaurantFoodTypeArraySelector(
                        icon,
                        index
                      )}
                    />
                  ))}
                </div>
              </div>
              <div className="suggest-button-heading">
                <SuggestNewButton categoryId={"5f562c9094ac7fdf47ea1d1b"} />
              </div>
              {/** */}
              {!isEmpty(selectedFoodIcons) ? (
                <React.Fragment>
                  <div className="f14-500 mt-4">
                    Out of the selections below, which one is primary?
                  </div>
                  <div className="f11-400 opacity5">
                    Select only one of the options below as a default - this is
                    shown to the user.
                  </div>
                </React.Fragment>
              ) : null}

              <div
                className="cuisine-main-padding-bottom justify-content-start column-2 mobile-device-bottom-margin mt-4"
                style={{ display: "flex", flexWrap: "wrap" }}
              >
                {selectedFoodIcons.map((icon, index) => (
                  <ReusableOnboardingMapButton
                    key={index}
                    classsection={
                      // icon._id === primaryFoodCategory._id
                      //   ?
                      "onboarding_mapbutton_reusable onboarding_mapbutton_reusable_active_two onboarding_mapbutton_reusable_type"
                      // : "onboarding_mapbutton_reusable onboarding_mapbutton_reusable_type onboarding_mapbutton_reusable_active"
                    }
                    src={icon.icon}
                    title={icon.title}
                    onClick={this.onRestaurantsFoodTypePrimarySelector(icon)}
                    displayPrimary={
                      icon._id === primaryFoodCategory._id ? true : false
                    }
                    displayRemove={true}
                    removeButtonClick={this.removeButton(icon)}
                  />
                ))}
              </div>
              {/* </div>
            <div className="cuisine-main "> */}
              {/* <h2 className="heading-title mt-2 mb-4">
                What category food do you provide?
              </h2>
              <div
                className={
                  allFoodIcons.length > 8 ? "cuisine-main-padding-border" : ""
                }
              >
                <div
                  id="box-style"
                  className="cuisine-main-padding"
                  style={{ display: "flex", flexWrap: "wrap" }}
                >
                  {allFoodIcons.map((icon, index) => {
                    return (
                      <ReusableOnboardingMapButton
                        key={index}
                        classsection={
                          selectedFoodIcons.some(
                            (icons) => icons._id === icon._id
                          )
                            ? "onboarding_mapbutton_reusable onboarding_mapbutton_reusable_type onboarding_mapbutton_reusable_activesingle"
                            : "onboarding_mapbutton_reusable onboarding_mapbutton_reusable_type"
                        }
                        src={icon.icon}
                        title={icon.title}
                        onClick={this.onSelectFoodCategoryArraySelector(icon)}
                      />
                    );
                  })}
                </div>
              </div> */}
              <hr />
              <div className="col-12">
                <div className="row mb-3 mt-5 health_and_senitation_onboarding_main_div">
                  <div className="col-10 pl-0 health_and_senitation_onboarding_main_divone">
                    <div className="f14-700 pb-3">Do you serve liquor?</div>
                  </div>
                  <div className="col-2 p-0 health_and_senitation_onboarding_main_divtwo">
                    <SlidingComponent
                      name="serve_liquor"
                      currentState={serve_liquor}
                      type={"checkbox"}
                      toggleclass={"toggle d-flex align-items-center mb-2"}
                      toggleinputclass={"toggle__switch"}
                      onChange={this.toggleFunctionliquor}
                      // slidingonClick={this.onSelecttogglestatusChange(data)}
                      defaultChecked={
                        this.state.serve_liquor === true ? true : false
                      }
                    />
                  </div>
                </div>
              </div>
              {serve_liquor ? (
                <div>
                  <div
                    className={
                      allFoodIcons.length > 8
                        ? "cuisine-main-padding-border"
                        : ""
                    }
                  >
                    <div
                      id="box-style"
                      className="cuisine-main-padding justify-content-start column-2"
                      style={{ display: "flex", flexWrap: "wrap" }}
                    >
                      {allLiquorIcons.map((icon, index) => (
                        <ReusableOnboardingMapButton
                          key={index}
                          classsection={
                            selectedLiquorIcons.some(
                              (icons) => icons._id === icon._id
                            )
                              ? "onboarding_mapbutton_reusable onboarding_mapbutton_reusable_type onboarding_mapbutton_reusable_activesingle"
                              : "onboarding_mapbutton_reusable onboarding_mapbutton_reusable_type"
                          }
                          src={icon.icon}
                          title={icon.title}
                          onClick={this.onSelectedServeLiquorArraySelector(
                            icon
                          )}
                        />
                      ))}
                    </div>
                  </div>
                  <div className="suggest-button-heading">
                    <SuggestNewButton categoryId={"5f562c9094ac7fdf47ea1d1c"} />
                  </div>
                </div>
              ) : null}
              <hr />
              <div className="col-12">
                <div className="row health_and_senitation_onboarding_main_div mb-4 mt-4">
                  {/* new-margin-cs */}
                  <div className="col-10 pl-0 health_and_senitation_onboarding_main_divone">
                    <div className="f14-500">
                      Do you allow Personalization on your dishes?
                    </div>
                    <div className="f11-400 opacity5">
                      <LearnMore
                        preText={
                          <>
                            If you allow personalization of items as per
                            customers aste let them know e.g. Salt, Sugar, Oil,
                            Cooking or other personalization option{" "}
                          </>
                        }
                        mainContent={
                          <div className="f14-400">
                            <div className="f16-500">
                              Personalization Information
                            </div>
                            <br />
                            If the Merchant has agreed to provide
                            Personalization Information, reasonable efforts are
                            made to describe the ingredients and Personalization
                            information on each of the menu items in detail and
                            items are properly tagged with the properties to
                            provide information related to it. Personalization
                            items are served as per the requests stipulated by
                            the users, Merchant shall make reasonable items to
                            substitute or make choice available as per choice of
                            User/Buyer. The Merchant shall be solely responsible
                            for the accuracy and conformity to facts of the
                            Personalization information provided by the Merchant
                            and displayed by the Amealio on its Platform. The
                            Merchant shall make all reasonable efforts for
                            strict adherence of the same and ensure that the
                            food items are in accordance with the
                            Personalization information as provided by them. In
                            the event, any mishap takes place or any claim
                            arises from the User/Buyer due to misrepresentation
                            of the Personalization information, the Merchant
                            shall be solely liable for the same and shall at no
                            point of time hold Amealio liable. The Merchant
                            further agrees to indemnify and keep indemnified the
                            Amealio for any claims, losses, costs, damages,
                            expenses and liabilities of any nature whatsoever
                            that may be sustained by Amealio due to any such
                            misrepresented or misleading Personalization
                            information.
                          </div>
                        }
                      />
                    </div>
                  </div>
                  <div className="col-2 p-0 health_and_senitation_onboarding_main_divtwo">
                    <SlidingComponent
                      name="personalization"
                      currentState={personalization}
                      type={"checkbox"}
                      toggleclass={"toggle d-flex align-items-center mb-2"}
                      toggleinputclass={"toggle__switch"}
                      onChange={this.toggleFunction("personalization")}
                      // slidingonClick={this.onSelecttogglestatusChange(data)}
                      defaultChecked={personalization === true ? true : false}
                    />
                  </div>
                  {personalization ? (
                    <div className="col-12 p-0 mt-3 text-area-labelText-padding">
                      <NewInputText
                        extraClass="text-area-labelText-padding-two mb-0"
                        name="personalizationText"
                        onChange={this.onChange}
                        onFocusOut={this.onFocusOut}
                        rows="3"
                        maxLength={250}
                        multiline={true}
                        value={this.state.personalizationText}
                        errorText={errors.personalizationText}
                        errorTrue={
                          errors.personalizationText ===
                          "*Fields can’t be blank. Please enter your personalization"
                            ? true
                            : false
                        }
                        labelText="personalization Description"
                        controlClass={
                          errors.personalizationText ===
                          "*Fields can’t be blank. Please enter your personalization"
                            ? "outlined-error-helper-text"
                            : "outlined-helperText "
                        }
                      />
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </div>
              <hr />
              <div className="col-12">
                <div className="row health_and_senitation_onboarding_main_div mb-4 mt-4">
                  {/* new-margin-cs */}
                  <div className="col-10 pl-0 health_and_senitation_onboarding_main_divone">
                    <div className="f14-500">
                      Do you have Allergy information on your dishes?
                    </div>
                    <div className="f11-400 opacity5">
                      <LearnMore
                        preText={
                          <>
                            Please note you may have to fill in info for items
                            during menu set up
                          </>
                        }
                        mainContent={
                          <div className="f14-400">
                            <div className="f16-500">Allergy Information</div>
                            <br />
                            If the Merchant has agreed to provide Allergy
                            Information, reasonable efforts are made to describe
                            the ingredients and allergy information on each of
                            the menu items in detail and items are properly
                            tagged with the properties to provide information
                            related to it. The Merchant shall be solely
                            responsible for the accuracy and conformity to facts
                            of the Allergy information provided by the Merchant
                            and displayed by the Amealio on its Platform. The
                            Merchant shall make all reasonable efforts for
                            strict adherence of the same and ensure that the
                            food items are in accordance with the Allergy
                            information as provided by them. In the event, any
                            mishap takes place or any claim arises from the
                            User/Buyer due to misrepresentation of the Allergy
                            information, the Merchant shall be solely liable for
                            the same and shall at no point of time hold Amealio
                            liable. The Merchant further agrees to indemnify and
                            keep indemnified the Amealio for any claims, losses,
                            costs, damages, expenses and liabilities of any
                            nature whatsoever that may be sustained by Amealio
                            due to any such misrepresented or misleading Allergy
                            information.
                          </div>
                        }
                      />
                    </div>
                  </div>
                  <div className="col-2 p-0 health_and_senitation_onboarding_main_divtwo">
                    <SlidingComponent
                      name="allergic_information"
                      currentState={allergic_information}
                      type={"checkbox"}
                      toggleclass={"toggle d-flex align-items-center mb-2"}
                      toggleinputclass={"toggle__switch"}
                      onChange={this.toggleFunction("allergy")}
                      // slidingonClick={this.onSelecttogglestatusChange(data)}
                      defaultChecked={
                        this.state.allergic_information === true ? true : false
                      }
                    />
                  </div>
                  {allergic_information ? (
                    <div className="col-12 p-0 mt-3 text-area-labelText-padding">
                      <NewInputText
                        extraClass="text-area-labelText-padding-two mb-0"
                        name="allergicInfoText"
                        onChange={this.onChange}
                        onFocusOut={this.onFocusOut}
                        rows="4"
                        multiline={true}
                        value={this.state.allergicInfoText}
                        errorText={errors.allergicInfoText}
                        errorTrue={
                          errors.allergicInfoText ===
                          "*Fields can’t be blank. Please enter your allergicInfoText"
                            ? true
                            : false
                        }
                        labelText="Allergy Description"
                        controlClass={
                          errors.allergicInfoText ===
                          "*Fields can’t be blank. Please enter your allergicInfoText"
                            ? "outlined-error-helper-text"
                            : "outlined-helperText "
                        }
                      />
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </div>
              <hr />
              <div className="col-12 margin-bottom-chains-onboarding">
                <div className="row health_and_senitation_onboarding_main_div">
                  <div className="col-10 pl-0 health_and_senitation_onboarding_main_divone">
                    <div className="f14-500">
                      Do you have Nutrition information on your dishes?
                    </div>
                    <div className="f11-400 opacity5">
                      <LearnMore
                        preText={
                          <>
                            Please note you may have to fill in info for items
                            during menu set up
                          </>
                        }
                        mainContent={
                          <div className="f14-400">
                            <div className="f16-500">Nutrition Information</div>
                            <br />
                            If the Merchant has agreed to provide Nutrition
                            Information, reasonable efforts are made to describe
                            the ingredients and Nutrition information on each of
                            the menu items in detail and items are properly
                            tagged with the properties to provide information
                            related to it. The Merchant shall be solely
                            responsible for the accuracy and conformity to facts
                            of the Nutrition information provided by the
                            Merchant and displayed by the Amealio on its
                            Platform. The Merchant shall make all reasonable
                            efforts for strict adherence of the same and ensure
                            that the food items are in accordance with the
                            Nutrition information as provided by them. In the
                            event, any mishap takes place or any claim arises
                            from the User/Buyer due to misrepresentation of the
                            Nutrition information, the Merchant shall be solely
                            liable for the same and shall at no point of time
                            hold Amealio liable. The Merchant further agrees to
                            indemnify and keep indemnified the Amealio for any
                            claims, losses, costs, damages, expenses and
                            liabilities of any nature whatsoever that may be
                            sustained by Amealio due to any such misrepresented
                            or misleading Nutrition information.
                          </div>
                        }
                      />
                    </div>
                  </div>
                  <div className="col-2 p-0 health_and_senitation_onboarding_main_divtwo">
                    <SlidingComponent
                      name="nutrition_information"
                      currentState={nutrition_information}
                      type={"checkbox"}
                      toggleclass={"toggle d-flex align-items-center mb-2"}
                      toggleinputclass={"toggle__switch"}
                      onChange={this.toggleFunction("nutritionInfo")}
                      // slidingonClick={this.onSelecttogglestatusChange(data)}
                      defaultChecked={
                        this.state.nutrition_information === true ? true : false
                      }
                    />
                  </div>
                  {nutrition_information ? (
                    <div className="col-12 p-0 mt-3 text-area-labelText-padding">
                      <NewInputText
                        extraClass="text-area-labelText-padding-two mb-0"
                        name="nutritionInfoText"
                        onChange={this.onChange}
                        onFocusOut={this.onFocusOut}
                        rows="4"
                        multiline={true}
                        value={this.state.nutritionInfoText}
                        errorText={errors.nutritionInfoText}
                        errorTrue={
                          errors.nutritionInfoText ===
                          "*Fields can’t be blank. Please enter your nutritionInfoText"
                            ? true
                            : false
                        }
                        labelText="Nutrition Description"
                        controlClass={
                          errors.nutritionInfoText ===
                          "*Fields can’t be blank. Please enter your nutritionInfoText"
                            ? "outlined-error-helper-text"
                            : "outlined-helperText "
                        }
                      />
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="onboarding-map-setup-screen-autodetect-button">
            <ReusableOnboardingButton
              buttonTitle="Back Button"
              buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_white"
              buttonText="Back"
              onClick={this.onPageChangeHandlerClosed}
            />
            <ReusableOnboardingButton
              buttonTitle="Next Button"
              buttonClass={
                selectedFoodIcons <= 0 ||
                (serve_liquor === true && selectedLiquorIcons <= 0) ||
                (Object.keys(primaryFoodCategory).length === 0 &&
                  primaryFoodCategory.constructor === Object)
                  ? "onboarding_button_link_reusable onboarding_button_link_reusable_gray ml-3"
                  : "onboarding_button_link_reusable onboarding_button_link_reusable_red ml-3"
              }
              disabled={
                selectedFoodIcons.length <= 0 ||
                (serve_liquor === true && selectedLiquorIcons.length <= 0) ||
                (Object.keys(primaryFoodCategory).length === 0 &&
                  primaryFoodCategory.constructor === Object)
                  ? true
                  : false
              }
              buttonText="Next"
              onClick={actionButton === false ? this.onWithOutApiCall : null}
              buttonType={actionButton === false ? "button" : "submit"}
            />
          </div>
        </div>
      </React.Fragment>
    );
  };
  handleFormShow = () => {
    this.setState({ formShow: true });
  };
  handleFormHide = () => {
    this.setState({ formShow: false });
  };
  render() {
    if (this.state.loader) {
      return <AmealioLoader />;
    }
    const { displayHomeCuisine, formShow } = this.state;
    return (
      <React.Fragment>
        <Media query="(max-width: 991px)">
          <>
            {!formShow && (
              <div className="bg-white min-height-100vh position-relative">
                <div className="mobileFirstScreen col-12">
                  <SliderMobileReusableComponent
                    displayShow={true}
                    selectedProgressBarOne="active"
                    selectedProgressBarTwo="active"
                    selectedProgressBarThree="active"
                    backLink={true}
                    onLink={"/healthsenitation"}
                    paragraphOne="Enter information diligently about your Business establishment. Users would like to know about your Business listed on our app. Take your time and fill information carefully"
                    paragraphTwo="Enter information diligently about your Business establishment. Users would like to know about your Business listed on our app. Take your time and fill information carefully"
                    paragraphThree="Enter information diligently about your Business establishment. Users would like to know about your Business listed on our app. Take your time and fill information carefully"
                    bottomImage={require("../../../../assets/images/illustratorImage/Amealio_Illustrations-04.svg")}
                  />
                </div>
                <div className="col-12 py-4">
                  <div className="f24_700_HelveticaNeue">Cuisine Setup</div>
                </div>
                <div className="border-top d-flex justify-content-center align-items-center p-3 fixed-bottom bg-white">
                  <ReusableOnboardingLink
                    buttonTitle="Back Button"
                    buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_white"
                    buttonText="Back"
                    link={"/healthsenitation"}
                  />
                  <ReusableOnboardingButton
                    buttonType="button"
                    buttonTitle="Next"
                    buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_red ml-3"
                    buttonText="Next"
                    onClick={this.handleFormShow}
                  />
                </div>
              </div>
            )}
          </>
        </Media>
        <div className={`container-fluid formShow ${formShow ? "active" : ""}`}>
          <div className="row">
            <div
              id="onboarding-scrollbar"
              className="col-12 col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 onboarding_process_screen_left"
            >
              <Media query="(min-width: 992px)">
                <div className="col-12 onboarding_process_screen_left-backbutton">
                  {displayHomeCuisine ? (
                    <div className="col-12">
                      <BackLogoIconButton
                        displayBackText={true}
                        displayArrow={true}
                        workWithLinkORClick={true}
                        backButtonClicked={this.onPageChangeHandlerClosed}
                      />
                    </div>
                  ) : (
                    <div className="col-12">
                      <BackLogoIconButton
                        displayBackText={true}
                        displayArrow={true}
                        backButtonClicked="/healthsenitation"
                      />
                    </div>
                  )}
                  {/* <div className="display-toggle-stepup-button">
                  <RightSidePannel selectedTab={this.state.selectedTab} />
                </div> */}
                </div>
              </Media>
              <Media query="(max-width: 991px)">
                <div className="col-12 onboarding_process_screen_left-backbutton">
                  {displayHomeCuisine ? (
                    <MobileTopHeader onClick={this.onPageChangeHandlerClosed} />
                  ) : (
                    <MobileTopHeader onClick={this.handleFormHide} />
                  )}
                </div>
              </Media>
              {displayHomeCuisine ? (
                <div className="onboarding_process_screen-button-map">
                  <div>
                    <TopTextReusableComponent
                      headingText="Food Category and Liquor Information"
                      headingParagraph="Enter the information about the food type provided in your Restaurant or Food Establishment."
                    />
                  </div>
                  <Form noValidate onSubmit={this.onHandleSubmit}>
                    {this.renderCuisineSetupInsideFields(
                      this.state.all_food_category,
                      this.state.selected_food_category,
                      this.state.primary_food_category,
                      this.state.all_serve_liquor,
                      this.state.selected_liquor_category,
                      this.state.personalization
                    )}
                  </Form>
                </div>
              ) : (
                <div className="onboarding_process_screen-left-mapinside">
                  <CuisineSetupHomeScreen
                    onClick={this.onPageChangeHandler}
                    handleFormHide={this.handleFormHide}
                  />
                </div>
              )}
            </div>
            <div className="col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 loginsignup-rightside">
              <SliderReusableComponent
                displayBarButton={true}
                displayHamburger={true}
                selectedProgressBarOne="active"
                selectedProgressBarTwo="active"
                selectedProgressBarThree="active"
                paragraphOne="Enter information diligently about your Business establishment. Users would like to know about your Business listed on our app. Take your time and fill information carefully"
                paragraphTwo="Enter information diligently about your Business establishment. Users would like to know about your Business listed on our app. Take your time and fill information carefully"
                paragraphThree="Enter information diligently about your Business establishment. Users would like to know about your Business listed on our app. Take your time and fill information carefully"
                bottomImage={require("../../../../assets/images/illustratorImage/Amealio_Illustrations-04.svg")}
              />
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

CuisineSetupOnboarding.propTypes = {
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors.errors,
  onboarding: state.onboarding.restaurantDetails,
  foodcategory: state.category.foodcategory,
  liquorcategory: state.category.liquorcategory,
});

export default connect(mapStateToProps, {
  clear_all_errors,
  create_and_update_restaurant,
})(withRouter(CuisineSetupOnboarding));
